import PatientForm from "./PatientForm.jsx";

export default PatientForm;
